<template>
  <div >
    <div v-if="$auth.ready()">
           <router-view></router-view>
       </div>
       <div class="splash" v-if="!$auth.ready()" >
         <div  class="container  d-flex h-100">
            <div class="row justify-content-center text-primary w-100 align-self-center text-white">
             <i class="fa fa-spin fa-spinner"></i>
            </div>
          </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
/* Import Font Awesome Icons Set */

$fa-font-path: '~@fortawesome/fontawesome-free/webfonts/';
@import '~@fortawesome/fontawesome-free/css/all.min.css';
/* Import Simple Line Icons Set */

$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/css/simple-line-icons.css';
/* Import Bootstrap Vue Styles */

@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '/static/styles/all.css';
</style>
<style lang="scss">
// Import Main styles for this application
@import './scss/style';
</style>



// WEBPACK FOOTER //
// App.vue?0aba060a